import React from 'react'
import { CopyToClipboardButton } from 'shared/components/copy-to-clipboard-button'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import {
  UserDomainWithWebsiteInterface,
  WebsiteId,
  WebsiteInterface,
} from '../types/website-interface'
import { getUrlWebsiteEdit } from '../utils/get-url'
import { WebsiteCreationStatusEnum } from 'modules/websites/enum/website-creation-status-enum'
import { StatusCell } from 'shared/components/table/cells/status-cell'
import { Tooltip } from '@systemeio/ui'
import { TimeCircleIcon } from '@systemeio/ui/icons'

export const websiteTableColumns = ({
  t,
  userDomainsWithWebsite,
  onNameClick,
}: {
  t: TLocoType
  userDomainsWithWebsite?: UserDomainWithWebsiteInterface[]
  onNameClick: (websiteId: WebsiteId) => void
}): ColumnDefinitionInterface<WebsiteInterface>[] => [
  // {
  //   key: 'previewImage',
  //   header: t('global.preview_image_label'),
  //   widthPercent: 20,
  //   onRender: () => <div className={'w-[180px] h-[105px] bg-skeleton-primary rounded-sm'} />,
  // },
  {
    key: 'name',
    header: t('global.name'),
    widthPercent: 45,
    onRender: website => {
      const isSharingWebsite = website.creationStatus === WebsiteCreationStatusEnum.Sharing

      return (
        <div className="truncate">
          {website.templateId &&
          website.homePage &&
          website.creationStatus === WebsiteCreationStatusEnum.Completed ? (
            <LinkWithoutPrefetch
              className="primary-link w-full cursor-pointer"
              href={getUrlWebsiteEdit(website.homePage.pageContentId) ?? ''}
            >
              {website.name}
            </LinkWithoutPrefetch>
          ) : isSharingWebsite ? (
            <span>{website.name}</span>
          ) : (
            <span
              className="primary-link w-full cursor-pointer"
              onClick={() => onNameClick(website.id)}
            >
              {website.name}
            </span>
          )}
        </div>
      )
    },
  },
  {
    key: 'path',
    header: t('dashboard.website.home_page_title'),
    onRender: website => {
      if (!userDomainsWithWebsite)
        return (
          <div className={'bg-skeleton-primary animate-pulse rounded-md px-10 text-transparent'}>
            .
          </div>
        )
      const domainName = userDomainsWithWebsite?.find(el => el.id === website.domainId)?.name

      const homePageUrl =
        domainName &&
        `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${domainName}/${website.homePagePath}`

      return homePageUrl ? (
        <div className="flex w-full gap-3">
          <div className="truncate">{homePageUrl}</div>
          <CopyToClipboardButton text={homePageUrl} />
        </div>
      ) : (
        <></>
      )
    },
    widthPercent: 45,
  },
  {
    key: 'active',
    header: t('global.status'),
    widthPercent: 10,
    onRender: website =>
      website.creationStatus === WebsiteCreationStatusEnum.Sharing ? (
        <Tooltip label={t('dashboard.website.website_tooltip_sharing_status')} mode="hover">
          <TimeCircleIcon className={`fill-yellow h-[16px] w-[16px] sm:h-[20px] sm:w-[20px]`} />
        </Tooltip>
      ) : (
        <StatusCell isActive={website.active} />
      ),
  },
]
